import { MarketConfiguration } from '../../../types/GeneralParameter';
import { VissVehicleTileDataQuery, VissVehicleTileDataQueryVariables } from '../../../types/viss/queries';
import { hasCriticalError } from '../../../util/viss/errorEvaluation';
import { ModeSpecificFetchClient } from '../../GenericFetchClient';

export const enum UseCase {
  MAIN = 'vehicle-card-main',
  LEGAL = 'vehicle-card-legal',
  PLS_PRICES = 'owcc-pls-input',
}

export type VissVehicleTileDataResponseWithId = VissVehicleTileDataQuery &
  MarketConfiguration & {
    responseTypeId: 'VissVehicleTileDataQuery';
  };

export type VissVehicleTileDataParams = VissVehicleTileDataQueryVariables & MarketConfiguration;

export class VissTeaserClient implements ModeSpecificFetchClient {
  private parameters?: VissVehicleTileDataParams;
  getInflateIdLength(): number {
    throw new Error('Method not implemented.');
  }
  setMode(): void {
    throw new Error('Method not implemented.');
  }

  setRequiredParameters(parameters: VissVehicleTileDataParams): void {
    this.parameters = parameters;
  }

  async getResponse(): Promise<VissVehicleTileDataResponseWithId> {
    const [{ vissClient: vissClientPromise }, { vehicleTileQuery: query }] = await Promise.all([
      import('@sccs-wishlist/shared-viss-client'),
      import('./queries/VehicleTileQuery'),
    ]);
    const gqlQueryParams = {
      query,
      variables: {
        useCases: [UseCase.MAIN, UseCase.LEGAL, UseCase.PLS_PRICES],
        ...this.parameters,
      },
    };
    const vissClient = await vissClientPromise;
    const vissResponse = await vissClient.query<VissVehicleTileDataQuery>({
      ...gqlQueryParams,
      errorPolicy: 'all',
    });

    let vehicle = {
      ...vissResponse?.data?.vehicle,
      usedCarId: this.parameters?.usedCarId?.productId,
    };

    if (vehicle?.hasCriticalVehicleTileError === undefined || vehicle?.hasCriticalVehicleTileError === null) {
      vehicle = {
        ...vehicle,
        hasCriticalVehicleTileError: hasCriticalError(vissResponse.errors, vehicle?.productType ?? undefined),
      };

      vissClient.writeQuery({
        ...gqlQueryParams,
        data: { vehicle },
      });
    }

    return {
      responseTypeId: 'VissVehicleTileDataQuery',
      market: this.parameters?.market ?? '',
      lang: this.parameters?.lang ?? '',
      vehicle,
    };
  }

  checkAllRequiredParametersPresent(): boolean {
    return Boolean(
      this.parameters &&
        (this.parameters.vehicleId || this.parameters.stockId || this.parameters.modelId || this.parameters.usedCarId),
    );
  }
}
